<div id="invitation" class="registration container">
  <form ng-class="{'form-complete': invitationCtrl.isFormCompleted}" #invitationForm="ngForm" name="invitationForm" (ngSubmit)="forward(invitationForm)" novalidate autocomplete="off" appScrollToInvalid [ngClass]="{'form-complete': isFormCompleted}">
    <h1 *ngIf="attendee.PAXTypeNo !== 27">{{ 'copy.label.INVITATION.header' | copy | async }}</h1>
    <h1 *ngIf="attendee.PAXTypeNo === 27">{{ 'copy.label.INVITATION.sponsorHeader' | copy | async }}</h1>
    <!-- <mtc-alert></mtc-alert> -->
    <section class="card" *ngIf="varTrack.Value !== 'Sponsor'">
      <div class="card-header">
        <div class="card-title">
          {{ 'copy.label.INVITATION.inviteQuestion' | copy | async }}
          <i class="fas fa-asterisk required"></i>
        </div>
      </div>
      <article>
        <div class="card-body">
          <div class="radio-group w-100">
            <div class="w-100 required">
              <mat-radio-group [(ngModel)]="invitation.isAttending" #attending="ngModel" name="attending" id="attending" required>
                <mat-radio-button [value]="true">Yes</mat-radio-button>
                <mat-radio-button [value]="false">No</mat-radio-button>
                <div class="w-100">
                  <mat-error><app-validation [object]="attending" isRequired=true></app-validation></mat-error>
                </div>
              </mat-radio-group>
            </div>
          </div>
        </div>
      </article>
    </section>
    <section class="card" *ngIf="attendee.PAXTypeNo === 27"> 
      <div class="card-header">
        <div class="card-title">
          <strong>
          {{ 'copy.label.INVITATION.sponsorSubHeader' | copy | async }}
        </strong>
        </div>
      </div>
      <article>
        <div class="card-body">
          <p [innerHTML]='"copy.label.INVITATION.sponsorInvitation" | copy | async'></p>
          <div [innerHTML]='"copy.html.sponsorInvitation" | copy | async'></div>
          <div [innerHTML]='"copy.html.sponsorLevels" | copy | async'></div>
        </div>
      </article>
    </section>

    <section class="card" *ngIf="invitation.isAttending === false">
      <div class="card-header">
        <div class="card-title">
          {{ 'copy.label.INVITATION.reasonQuestion' | copy | async }}
          <i class="fas fa-asterisk required"></i>
        </div>
      </div>
      <article *ngIf="attendee.PAXTypeNo !== 20 && attendee.PAXTypeNo !== 21 && attendee.PAXTypeNo !== 29">
        <div class="card-body">
          <div class="radio-group w-100">
            <mat-radio-group class="w-100" [(ngModel)]="invitation.declineOption" name="declineOption" #declineOption="ngModel" required>
              <mat-radio-button *ngFor="let op of declineRadios" [value]="op.value">{{op.display}}</mat-radio-button>
              <div class="w-100">
                <mat-error><app-validation [object]="declineOption" isRequired=true></app-validation></mat-error>
              </div>
            </mat-radio-group>
          </div>
          <div class="d-flex justify-content-start flex-column w-100" *ngIf="invitation.declineOption === 'other'">
            <mat-form-field class="w-100 mb-0">
              <mat-label for="declineComment" aria-labelledby="declineComment">{{"copy.label.INVITATION.description"|copy |async}}</mat-label>
              <textarea matInput class="w-100" name="declineComment" id="declineComment" aria-label="declineComment" [(ngModel)]="invitation.declineComment" maxlength="225" #declineComment="ngModel" required></textarea>
            </mat-form-field>
            <div class="w-100">
              <mat-error><app-validation [object]="declineComment" isRequired=true pattern="alpha"></app-validation></mat-error>
            </div>
          </div>
        </div>
      </article>
      <article *ngIf="attendee.PAXTypeNo === 20 || attendee.PAXTypeNo === 21 || attendee.PAXTypeNo === 29">
        <div class="card-body">
          <div class="d-flex justify-content-start flex-column w-100">
            <mat-form-field class="w-100 mb-0">
              <mat-label for="declineComment" aria-labelledby="declineComment">{{"copy.label.INVITATION.description"|copy |async}}</mat-label>
              <textarea matInput class="w-100" name="declineComment" id="declineComment" aria-label="declineComment" [(ngModel)]="invitation.declineComment" maxlength="225" #declineComment="ngModel" required></textarea>
            </mat-form-field>
            <div class="w-100">
              <mat-error><app-validation [object]="declineComment" isRequired=true pattern="alpha"></app-validation></mat-error>
            </div>
          </div>
        </div>
      </article>
    </section>

    <div class="button_group d-flex">
      <button id="back-button" type="button" class="back btn btn-outline-primary" (click)="back()" *ngIf="!isSubmitting">
        <!-- <i class="material-symbols-outlined icon-align">chevron_left</i> -->
        {{ 'copy.label.GLOBAL.goback' | copy | async }}
      </button>
      <button id="forward-button" type="submit" class="inputSubmit btn btn-primary" *ngIf="!isSubmitting && attendee.PAXTypeNo !== 27">
        {{ 'copy.label.GLOBAL.continue' | copy | async }}
        <!-- <i class="material-symbols-outlined icon-align">chevron_right</i> -->
      </button>
      <button id="forward-button" type="submit" class="inputSubmit btn btn-primary" *ngIf="!isSubmitting && attendee.PAXTypeNo === 27">
        {{ 'copy.label.INVITATION.sponsorContinue' | copy | async }}
        <!-- <i class="material-symbols-outlined icon-align">chevron_right</i> -->
      </button>
      <button class="inputSubmit btn btn-primary ml-auto" *ngIf="isSubmitting">
        <i class="fas fa-spinner fa-spin"></i>
      </button>
    </div>
  </form>
</div>
